class DashboardController {
	constructor($rootScope, $filter){
		'ngInject';
		const vm = this;

		vm.rootScope = $rootScope;

		let $transalte = $filter('translate');
	}
}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.controller.js